import { Box, Container } from "@chakra-ui/react"
import PaginationBase from "./PaginationBase"

type PaginationFooterProps = {
  onChangePage: (newPage: number) => void
  page: number
  count: number | 0
  perPage: number
}


export function PaginationFooter({
  onChangePage,
  page,
  count,
  perPage,
}: PaginationFooterProps) {
  return (
    <Box>
      <Container py={{ base: "12", md: "16" }}>
        <PaginationBase
          count={count}
          pageSize={perPage}
          page={page}
          onPageChange={(e) => onChangePage(e.page)} />
      </Container>
    </Box>
  )
}
